import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRecentReports } from "../lib/api";

export default function RecentReports() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRecentReports(48)
      .then((d) => setItems(d.reports || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="border-b border-black" data-testid="recent-page">
      <section className="border-b border-black">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#0047FF] mb-3">
            / Public reports
          </div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-[0.95] max-w-3xl">
            Every site PrivacyLens has scanned.
          </h1>
          <p className="text-[#475569] mt-5 max-w-xl text-lg">
            Browse the public TrustScore database — see how brands stack up.
          </p>
        </div>
      </section>

      <section className="border-b border-black bg-[#F8F9FA]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
          {loading ? (
            <div className="text-center py-16 font-mono text-sm uppercase tracking-widest text-[#475569]">
              Loading…
            </div>
          ) : items.length === 0 ? (
            <div className="border border-dashed border-[#E2E8F0] p-12 text-center text-[#475569]">
              <div className="font-mono uppercase tracking-widest text-sm">
                No public reports yet
              </div>
              <Link to="/" className="inline-block mt-4 pl-btn-primary px-5 py-2.5 text-sm border border-black">
                Be the first
              </Link>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-[#E2E8F0] border border-[#E2E8F0]" data-testid="recent-grid">
              {items.map((r) => {
                const c =
                  r.trust_score >= 80
                    ? "#10B981"
                    : r.trust_score >= 60
                    ? "#F59E0B"
                    : "#EF4444";
                return (
                  <Link
                    key={r.id}
                    to={`/report/${r.domain}`}
                    className="bg-white p-5 hover:bg-[#FAFAFA] flex flex-col"
                    data-testid={`recent-card-${r.domain}`}
                  >
                    <div className="font-mono text-[10px] uppercase tracking-widest text-[#475569] truncate">
                      {r.domain}
                    </div>
                    <div className="flex items-end gap-1.5 mt-3">
                      <span className="font-display text-5xl leading-none" style={{ color: c }}>
                        {r.trust_score}
                      </span>
                      <span className="text-[10px] font-mono text-[#475569] pb-1">/100</span>
                    </div>
                    {r.summary && (
                      <p className="text-xs text-[#475569] mt-3 line-clamp-3 leading-relaxed">
                        {r.summary}
                      </p>
                    )}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
